import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { NavbarComponent } from './navbar.component';
import { MaterialModule } from 'src/app/app.module';
import { MatBadgeModule } from '@angular/material/badge';
@NgModule({
    imports: [ RouterModule, CommonModule, MaterialModule, MatBadgeModule ],
    declarations: [ NavbarComponent ],
    exports: [ NavbarComponent ]
})

export class NavbarModule {}
